import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
    form__images: ({ showMode }) =>
        !showMode
            ? {
                  position: 'relative',
                  margin: 'auto',
                  marginTop: '8vh',
                  padding: '10px',
                  borderRadius: '9px',
                  backgroundColor: '#f4f4f4',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',

                  // minHeight: '225px',
                  minHeight: '200px',
                  flexWrap: 'wrap',

                  [theme.breakpoints.up(1025)]: {
                      '& > div': {
                          minWidth: '100px !important'
                      }
                  },
                  [theme.breakpoints.down(1025)]: {
                      backgroundColor: '#fff',
                      marginTop: '10vh',

                      '& > div': {
                          minWidth: '80px !important',
                          width: '100% ',
                          maxHeight: '120px !important',
                          height: '100%'
                      }
                  },

                  [theme.breakpoints.down('450')]: {
                      minWidth: '160px !important',
                      width: '100% ',
                      flex: 1
                  },
                  [theme.breakpoints.down('400')]: {
                      minWidth: '140px !important',
                      width: '100% ',
                      flex: 1
                  },
                  [theme.breakpoints.down('350')]: {
                      minWidth: '250px !important',
                      width: '100% ',
                      flex: 1
                  }
              }
            : {
                  padding: '10px 0px 10px 3px',
                  marginTop: '10px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  flexWrap: 'wrap',
                  [theme.breakpoints.down(1025)]: {
                      justifyContent: 'center ',
                      padding: '10px 0px 10px 0px'
                  }
              },

    image__container: ({ showMode, isAddRadiology }) =>
        !showMode
            ? {
                  height: isAddRadiology ? '130px !important' : '160px !important',
                  width: isAddRadiology ? '130px !important' : '159px',
                  marginLeft: '4px',
                  marginRight: '4px',
                  marginTop: '10px'
              }
            : {
                  marginBottom: '14px',
                  width: '360px !important',
                  height: '240px',
                  [theme.breakpoints.down(1025)]: {
                      width: 'unset'
                  }
              },
    form__add__image__container: {
        marginTop: '10px',
        borderRadius: 9,
        backgroundColor: '#ffffff',
        width: '159px',
        height: '160px',
        position: 'relative',
        cursor: 'pointer'
    },
    form__add__image: {
        position: 'absolute',
        top: '51.5px',
        left: '51.5px',
        height: '50px',
        width: '50px'
    },

    add__image: {
        marginTop: '10px',
        height: '46px',
        width: '46px'
    },
    image: {
        minHeight: '100px !important'
    },
    title: {
        fontFamily: 'inherit',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.06,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#232733'
    }
}));

export default styles;
